import React from 'react';
import { Route } from 'react-router-dom';

import NotFound404 from '@pages/404';
import NoPermissions from '@pages/no-permissions';
import { RemoteDiagnosticPage } from '@pages/remote-diagnostic';
import { DiagnosticLayout } from '../layouts/diagnostic-layout';

export const getPublicRoutes = () => [
  <Route
    key="diagnostic"
    path="/diagnostic"
    element={
      <DiagnosticLayout>
        <RemoteDiagnosticPage />
      </DiagnosticLayout>
    }
  />,
  <Route key="404" path="*" element={<NotFound404 />} />,
  <Route key="403" path="errors/403" element={<NoPermissions />} />,
];
